/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Calendar_BrokersInputs */

const cs_calendar_brokers = /** @type {(inputs: Calendar_BrokersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Makléři`)
};

const en_calendar_brokers = /** @type {(inputs: Calendar_BrokersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brokers`)
};

/**
* | output |
* | --- |
* | "Brokers" |
*
* @param {Calendar_BrokersInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const calendar_brokers = /** @type {((inputs?: Calendar_BrokersInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calendar_BrokersInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_calendar_brokers(inputs)
	return cs_calendar_brokers(inputs)
});